export const seedCountries = [
  {
    "id": "country_seed_0",
    "name": "일본",
    "createdAt": "2026-02-13T06:35:02.602Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  },
  {
    "id": "country_seed_1",
    "name": "프랑스",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  },
  {
    "id": "country_seed_2",
    "name": "중국",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  },
  {
    "id": "country_seed_3",
    "name": "미국",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  },
  {
    "id": "country_seed_4",
    "name": "태국",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  },
  {
    "id": "country_seed_5",
    "name": "베트남",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  },
  {
    "id": "country_seed_6",
    "name": "대만",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  },
  {
    "id": "country_seed_7",
    "name": "말레이시아",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  },
  {
    "id": "country_seed_8",
    "name": "싱가포르",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  },
  {
    "id": "country_seed_9",
    "name": "홍콩",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  },
  {
    "id": "country_seed_10",
    "name": "마카오",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  }
];
export const seedRegions = [
  {
    "id": "region_seed_0",
    "name": "오사카",
    "countryId": "country_seed_0",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  },
  {
    "id": "region_seed_1",
    "name": "우메다",
    "countryId": "country_seed_0",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  },
  {
    "id": "region_seed_2",
    "name": "도쿄",
    "countryId": "country_seed_0",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  },
  {
    "id": "region_seed_3",
    "name": "파리",
    "countryId": "country_seed_1",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  },
  {
    "id": "region_seed_4",
    "name": "상하이",
    "countryId": "country_seed_2",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  },
  {
    "id": "region_seed_5",
    "name": "베이징",
    "countryId": "country_seed_2",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  },
  {
    "id": "region_seed_6",
    "name": "LA",
    "countryId": "country_seed_3",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  },
  {
    "id": "region_seed_7",
    "name": "올랜도",
    "countryId": "country_seed_3",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  },
  {
    "id": "region_seed_8",
    "name": "할리우드",
    "countryId": "country_seed_3",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  },
  {
    "id": "region_seed_9",
    "name": "방콕",
    "countryId": "country_seed_4",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  },
  {
    "id": "region_seed_10",
    "name": "다낭",
    "countryId": "country_seed_5",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  },
  {
    "id": "region_seed_11",
    "name": "푸꾸옥",
    "countryId": "country_seed_5",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  },
  {
    "id": "region_seed_12",
    "name": "나트랑",
    "countryId": "country_seed_5",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  },
  {
    "id": "region_seed_13",
    "name": "달랏",
    "countryId": "country_seed_5",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  },
  {
    "id": "region_seed_14",
    "name": "타이베이",
    "countryId": "country_seed_6",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  },
  {
    "id": "region_seed_15",
    "name": "핑시",
    "countryId": "country_seed_6",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  },
  {
    "id": "region_seed_16",
    "name": "쿠알라룸푸르",
    "countryId": "country_seed_7",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  },
  {
    "id": "region_seed_17",
    "name": "마리나 베이 샌즈",
    "countryId": "country_seed_8",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  },
  {
    "id": "region_seed_18",
    "name": "센토사",
    "countryId": "country_seed_8",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  },
  {
    "id": "region_seed_19",
    "name": "주얼 창이",
    "countryId": "country_seed_8",
    "createdAt": "2026-02-13T06:35:02.603Z",
    "updatedAt": "2026-02-13T06:35:02.603Z"
  }
];
